import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  wizard: {
    required: {
      infos: {
        email: "",
        prefix: "",
        firstname: "",
        lastname: "",
        isPro: "no",
        adresse: "",
        city: "",
        postalcode: "",
        phone: "",
        proxiserve_optin: false,
      },
    },
    optional: {
      infos: {
        comment_info: "",
        commentInfo: false,
        createAccount: false,
      },
    },

    billingInfo: {
      billingFirstname: "",
      billingLastname: "",
      billingAdresse: "",
      billingCity: "",
      billingPostalcode: "",
      billingPhone: "",
    },

    fillPercent: 0,
    fillPercentLast: 0,

    strapiFormId: 0,
    form: {}, // strapi object
    answers: {}
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
